import {
  Entity,
  Column,
  PrimaryGeneratedColumn,
  Index,
  ManyToMany,
  JoinTable,
} from "typeorm";
import { Permission } from "./";
import { UserRoles } from "../enums";

@Entity()
export class Role {
  @PrimaryGeneratedColumn() id: number;

  @Index({ unique: true })
  @Column("varchar")
  slug: string;

  @Column("varchar") name: string;

  @ManyToMany(() => Permission)
  @JoinTable()
  permissions: Permission[];

  static async getOrCreate(slug: string, dbConn: any) {
    if (!Object.keys(UserRoles).some((r) => r === slug)) {
      throw "There is no UserRole " + slug + " defined in its enums";
    }
    const roleRepository = await dbConn.getRepository(this);
    let role = await roleRepository.findOne({
      where: { slug },
      relations: ["permissions"],
    });
    if (role) return role;
    role = new Role();
    role.slug = slug;
    role.name = slug
      .split("_")
      .map(
        (s) => s.substring(0, 1).toUpperCase() + s.substring(1).toLowerCase()
      )
      .join(" ");
    role.permissions = [];
    const PermissionRepository = await dbConn.getRepository(Permission);
    const rolePermissions = UserRoles[slug].permissions;
    for (const p in rolePermissions) {
      let permission = await PermissionRepository.findOne({
        where: {
          slug: rolePermissions[p],
        },
      });
      if (!permission) {
        permission = new Permission();
        permission.slug = UserRoles[slug].permissions[p];
        permission.name = UserRoles[slug].permissions[p]
          .split("_")
          .map(
            (s) =>
              s.substring(0, 1).toUpperCase() + s.substring(1).toLowerCase()
          )
          .join(" ");
        permission = await PermissionRepository.save(permission);
      }
      role.permissions.push(permission);
    }
    role = await roleRepository.save(role);
    return role;
  }
}
